<template>
    <div v-html="block.value.content" ref="wysiwygRef" class="wysiwyg"></div>
</template>

<script>
import LoadingIndicator from '@/components/LoadingIndicator'
import { openInNewWindow } from "@/utils/url";

export default {
    name: 'WysiwygBlock',
    components: {
        LoadingIndicator
    },
    props: {
        block: Object
    },
    methods: {
        handleClick(event) {
            if (event.target.tagName === 'IMG') {
                const originalSrc = event.target.src.replace(/(\.[^.]+)\.(\w+)$/, '.original.$2');
                openInNewWindow(originalSrc);
            }
        },
        tagVerticalImages(){
            const images = this.$refs.wysiwygRef.querySelectorAll('img');
            images.forEach(image => {
                if ((image.width < image.height) && image.height >= 700) {
                    image.classList.add('portrait');
                }
            });
        }
    },
    mounted() {
        this.$refs.wysiwygRef.addEventListener('click', this.handleClick);
        this.tagVerticalImages();
    }
}
</script>

<style scoped>
.wysiwyg::v-deep img {
    width: 100%;
    height: auto;
}

.wysiwyg::v-deep img:hover {
    cursor: pointer;
}

.wysiwyg::v-deep img.portrait {
    width: 50%;
}
</style>
